package com.vizio.redwolf.utils

actual class MessageTokenUtil {
    actual fun generateMessageToken(email: String, secretKey: String): String? {
        println("generateMessageToken() not required for JS")
        return null
    }
}